import { defineMessages } from 'react-intl';

type MessageKeys = 'newChatButtonLabel' | 'newChatButtonLabelFullScreen';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		newChatButtonLabel: {
			id: 'ai-mate.main-chat.new-chat-button-label',
			defaultMessage: 'New',
			description:
				'Button label displayed on the new chat button in the main chat interface within the AI conversation interface. Shown as the text on a button, typically in a compact view. When clicked, it starts a new conversation session, clearing the current chat history. The purpose is to provide users with a quick way to begin a fresh conversation with the AI assistant.',
		},
		newChatButtonLabelFullScreen: {
			id: 'ai-mate.main-chat.new-chat-button-label-full-screen',
			defaultMessage: 'New chat',
			description:
				'Button label displayed on the new chat button in the main chat interface when in full screen mode within the AI conversation interface. Shown as the text on a button. When clicked, it starts a new conversation session, clearing the current chat history. The purpose is to provide users with a clear way to begin a fresh conversation, with the expanded label providing more context in the full screen view.',
		},
	});

export default message;
